<template>
    <div class="lke-title">
        <div class="lke-l"></div>
        <div class="lke-r">
            <span class="lke-r-l">
                {{title}}
            </span>
            <span class="lke-r-r">
                <router-link :to="link" style="text-decoration:none">
                    更多<i class="el-icon-caret-right"></i>
                </router-link>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'vTopTitle',
    props: {
        title:String,
        link: String,
    },
    data() {
        return {

        };
    },
    computed: {

    },
    created() {

    },
    mounted() {

    },
    watch: {

    },
    methods: {

    },
    components: {

    },
};
</script>

<style>

</style>

<style scoped>
.lke-title{
    display: flex;
    align-items: center;
    margin-bottom: 5px;
}
.lke-l{
    width: 10px;
    background: #2890F4;
    height: 30px;
}
.lke-r{
    height: 30px;
    padding: 0 10px;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #ccc
}
.lke-r-l{
    font-size: 16px;
}
.lke-r-r > a{
    font-size: 12px;
    cursor: pointer;
    color: #333 !important;
}
.lke-r-r:hover > a{
    color: #2890F4 !important;
}
.lke-r-r  i{
    color: #2890F4 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/page/grzx/components/tabBur.vue